import { render, staticRenderFns } from "./nebikiRtRate.vue?vue&type=template&id=8f84f866&"
import script from "./nebikiRtRate.vue?vue&type=script&lang=js&"
export * from "./nebikiRtRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports